module.exports = __webpack_public_path__ + "static/media/ipad.ee37b5ea.png";